import { useState } from "react";
import { SearchPopup } from "../SearchPopup/SearchPopup";
import "./SRConsole.scss";
import SRConsoleHero from "./SRConsoleHero";

export default function SRConsole() {
    const [searchPopupVisible, setSearchPopupVisible] = useState(false);

    const handleSearchClick = (value: boolean) => {
        setSearchPopupVisible(value);
    };

    return (
        <>
            <SRConsoleHero onSearchClick={() => handleSearchClick(true)} />

            {searchPopupVisible && (
                <SearchPopup
                    onClose={() => handleSearchClick(false)} />
            )}
        </>
    );
}